<script setup lang="ts">
import { ref } from 'vue';

import Button from 'lib/components/button/Button.vue';
import Icon from 'lib/components/icon/Icon.vue';

import { ButtonCopyProps } from './ButtonCopy.vue.d';

const props = defineProps<ButtonCopyProps>();

const copied = ref(false);

const copy = async (): Promise<void> => {
  try {
    await navigator.clipboard.writeText(props.text);
    copied.value = true;
    setTimeout(() => (copied.value = false), 2000);
  } catch {
    /* Ignore write failure */
  }
};
</script>

<template>
  <Button @click="copy" class="p-0 m-0" data-wv-name="buttoncopy" text>
    <Icon
      :class="
        copied ? 'text-green-500' : 'text-general-200 dark:text-general-500'
      "
      :icon="copied ? 'check' : 'file-copy'"
      class="h-[14px] text-sm"
    />
  </Button>
</template>
